"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trainerEvents = void 0;
exports.trainerEvents = {
    fileUploaded: 'trainer.fileUploaded',
    textCopied: 'trainer.textCopied',
    dataUploaded: 'trainer.dataUploaded',
    uploadError: 'trainer.uploadError',
    uploadSuccess: 'trainer.uploadSuccess',
    uploadWarning: 'trainer.uploadWarning',
    configUpdated: 'trainer.configUpdated',
    configChanged: 'trainer.configChanged',
    configValidated: 'trainer.configValidated',
    trainingStarted: 'trainer.trainingStarted',
    trainingProgress: 'trainer.trainingProgress',
    trainingCompleted: 'trainer.trainingCompleted',
    trainingError: 'trainer.trainingError',
    trainingStopped: 'trainer.trainingStopped',
    deployModel: 'trainer.deployModel',
    testModel: 'trainer.testModel',
    activeTabSet: 'trainer.activeTabSet',
};
